import type { UseCase } from '@/core/shared'
import type { AuthRepository } from '../domain'

export const doOauthSignUp: UseCase<AuthRepository, 'oauthSignUp'> = repository => {
  return async (signUp) => {
    await repository.oauthSignUp(signUp)
  }
}
